export enum DocumentStatus {
  ODBR = 'ODBR',
  PRZY = 'PRZY',
}
